var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M4.595 8.827A.62.62 0 0 1 4.162 9a.62.62 0 0 1-.433-.173L.269 5.485a.866.866 0 0 1 0-1.256l.433-.418a.94.94 0 0 1 1.3 0l2.16 2.086L10 .26a.94.94 0 0 1 1.3 0l.433.419c.359.346.359.909 0 1.255z"
  })));
};
export default SvgCheck;